// Libraries
var React = require('react');
var cloneDeep = require('lodash/cloneDeep');

// Components
var SupportersClubListModule = require('../SupportersClub/List');
var Icon = require('../../common/Icon/Icon.js');

// Styles
require('../ListingCardFilters/ListingCardFilters.scss');
require('../Filters/Filters.scss');
require('../LoadingWrapper/LoadingWrapper.scss');
require('../NoResults/NoResults.scss');

class SupportersClubSearchModule extends React.Component {
  constructor(props) {

    super(props);

    this.state = {
      showFiltersMobile: false,
      loadMoreUrl: this.props.data.searchResults.loadMoreUrl,
      isLoadingMore: false,
      isLoading: false,
      isPopulatingLocations: true,
      isError: false,
      results: this.props.data.searchResults.results,
      locations: [],
      continents: [],
      countries: [],
      regions: [],
      continent: this.props.data.searchRequest.continent || 0,
      country: this.props.data.searchRequest.country || 0,
      region: this.props.data.searchRequest.region || 0,
      interacted: false
    }

    if (typeof window === 'undefined') return;

    this.populateLocations();

  }

  populateLocations() {

    const minimumWaitTime = 500;
    const startRequestTime = performance.now();

    this.getData(this.props.data.locationsEndpoint).then(locations => {

      const timeTaken = parseInt(performance.now() - startRequestTime);
      const waitTime = (timeTaken < minimumWaitTime) ? (minimumWaitTime - timeTaken) : 0;

      setTimeout(() => {

        this.setState({
          locations: locations,
          isPopulatingLocations: false
        });
  
        this.resetLocations();
  
      }, waitTime);

    }).catch(()=> {
      
      this.setState({ isError: true });

    });

  }

  resetLocations() {

    let continents = [];
    let countries = [];
    let regions = [];

    let locationsClone = cloneDeep(this.state.locations);

    {locationsClone.map((continent) => {

      continents.push(continent);
      {continent.locations.map((country) => { countries.push(country); })}

    })}

    if (this.state.continent) {

      let continent = locationsClone.find(o => o.id === this.state.continent);
      
      if (continent) {
        
        countries = [];
        {continent.locations.map((country) => { countries.push(country); })}

      }

    }

    if (this.state.country) {

      let country = locationsClone.map((o) => o.locations).flat().find((o) => o.id === this.state.country);
      if (country) { {country.locations.map((region) => { regions.push(region); })} }

    }

    this.setState({
      continents: continents,
      countries: countries,
      regions: regions
    });

    let url = new URL(window.location.origin + window.location.pathname);
    if (this.state.continent) url.searchParams.set('continent', this.state.continent);
    if (this.state.country) url.searchParams.set('country', this.state.country);
    if (this.state.region) url.searchParams.set('region', this.state.region);
    window.history.replaceState({}, '', url);

  }

  loadResults(loadingMore) {

    const minimumWaitTime = 1000;
    const startRequestTime = performance.now();

    this.setState({
      isLoading: !loadingMore,
      isLoadingMore: loadingMore,
      isError: false,
      interacted: true
    });

    let requestUrl = loadingMore ? new URL(window.location.origin + this.state.loadMoreUrl) : new URL(window.location.origin + this.props.data.resultsEndpoint);

    if (!loadingMore) {

      if (this.state.continent) requestUrl.searchParams.set('continent', this.state.continent);
      if (this.state.country) requestUrl.searchParams.set('country', this.state.country);
      if (this.state.region) requestUrl.searchParams.set('region', this.state.region);

    }

    this.getData(requestUrl).then(response => {

      const results = loadingMore ? cloneDeep(this.state.results).concat(response.results) : response.results;

      const timeTaken = parseInt(performance.now() - startRequestTime);
      const waitTime = (timeTaken < minimumWaitTime) ? (minimumWaitTime - timeTaken) : 0;

      setTimeout(() => {

        this.setState({
          isLoading: false,
          isLoadingMore: false,
          loadMoreUrl: response.loadMoreUrl,
          results: results
        });
  
      }, waitTime);

    }).catch(()=> {
      
      this.setState({ isError: true });

    });

  }

  getData(endpoint) {

    return fetch(endpoint).then(response => {
      if (!response.ok) { throw response; }
      return response.json();
		}).then(json => { return json; });

  }

  handleToggleFiltersDisplay() {

    this.setState({
      showFiltersMobile: !this.state.showFiltersMobile
    });

  }

  handleContinentChange(event) {

    const continentId = parseInt(event.target.value);

    this.setState({
      continent: continentId,
      country: 0,
      region: 0
    }, function() {
      this.resetLocations();
      this.loadResults();
    });

  }

  handleCountryChange(event) {

    const countryId = parseInt(event.target.value);
    let continentId = this.state.continent;

    if (countryId) {

      let locationsClone = cloneDeep(this.state.locations);

      {locationsClone.map((continent) => {
        
        let country = continent.locations.find(o => o.id === countryId);
        if (country) continentId = continent.id;

      })}

    }

    this.setState({
      country: countryId,
      continent: continentId,
      region: 0
    }, function() {
      this.resetLocations();
      this.loadResults();
    });

  }

  handleRegionChange(event) {

    const regionId = parseInt(event.target.value);

    this.setState({ region: regionId }, function() {
      this.resetLocations();
      this.loadResults();
    });

  }

  handleShowMore() {

    this.loadResults(true);

  }

  render() {
    return (
      <div id={this.props.data.id}>

        <div class={`c-loading-wrapper c-loading-wrapper--top${this.state.isLoading ? " c-loading-wrapper--loading" : ""}`}>

          <div className={`c-filters c-filters--standalone${this.props.data.isPremium ? " c-filters--premium" : ""}`}>

            <h2 className="c-filters__title">Find a Supporters' Club</h2>

            <button type="button" className={`c-filters__toggle ${this.state.showFiltersMobile ? 'is-open' : ''}`} onClick={this.handleToggleFiltersDisplay.bind(this)}>
              <Icon name="filters" width={25.246} height={23.502} className="c-filters__toggle-icon c-filters__toggle-icon--filters" />
              <span className="c-filters__toggle__text">{this.state.showFiltersMobile ? 'Hide ' : 'Show'} filters</span>
              <Icon name="chevronRightAlt" width={23.996} height={14.897} className="c-filters__toggle-icon c-filters__toggle-icon--arrow" />
            </button>

            <div className={`c-filters__primary${this.state.showFiltersMobile ? ' is-open' : ''}`}>
              <div className="c-filters__primary__inner">
                
                <div className="c-filters__primary__control c-filters__primary__control--supporters">
                  <label htmlFor="loc-continent" className="c-filters__label">Continent</label>
                  <div className={`c-filters__select-wrapper${this.state.isPopulatingLocations ? ' c-filters__select-wrapper--loading' : ''}`}>
                    <select id="loc-continent" name="Continent" onChange={this.handleContinentChange.bind(this)} className="c-filters__select" value={this.state.continent}>
                      <option value="0">Please select</option>
                      {this.state.continents.map((continent, index) => {
                        return(
                          <option key={index} value={continent.id}>{continent.name}</option>
                        );
                      })}
                    </select>
                    </div>
                </div>

                <div className="c-filters__primary__control c-filters__primary__control--supporters">
                  <label htmlFor="loc-country" className="c-filters__label">Country</label>
                  <div className={`c-filters__select-wrapper${this.state.isPopulatingLocations ? ' c-filters__select-wrapper--loading' : ''}`}>
                    <select id="loc-country" name="Country" onChange={this.handleCountryChange.bind(this)} className="c-filters__select" value={this.state.country} disabled={!this.state.countries.length}>
                      <option value="0">Please select</option>
                      {this.state.countries.map((country, index) => {
                        return(
                          <option key={index} value={country.id}>{country.name}</option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="c-filters__primary__control c-filters__primary__control--supporters">
                  <label htmlFor="loc-region" name="Region" className="c-filters__label">City/Region</label>
                  <select id="loc-region" onChange={this.handleRegionChange.bind(this)} className="c-filters__select" value={this.state.region} disabled={!this.state.regions.length}>
                    {(this.state.regions.length) &&
                      <option value="0">Please select</option>
                    }
                    {this.state.regions.map((region, index) => {
                      return(
                        <option key={index} value={region.id}>{region.name}</option>
                      );
                    })}
                  </select>
                </div>

              </div>
            </div>
          </div>

          {(this.state.isError) &&
            <div className="c-section c-section--supporters-clubs">
              <div className="c-section__inner">
                <div className="c-section__inner__inner">
                  <p className="c-no-results" role="status">Sorry!  Something went wrong.  Try reloading the page.</p>
                </div>
              </div>
            </div>
          }

          {(!this.state.isError) &&
            <div>

              {(!this.state.results.length) &&
                <div className="c-section c-section--supporters-clubs">
                  <div className="c-section__inner">
                    <div className="c-section__inner__inner">
                      <p className="c-no-results" role="status">No results found for your selection.</p>
                    </div>
                  </div>
                </div>
              }

              <SupportersClubListModule results={this.state.results} premium={this.props.data.isPremium} />

              {(this.state.loadMoreUrl && this.state.loadMoreUrl !== '') &&
                <div className="c-section c-section--supporters-clubs-more c-section--center">
                  <div className="c-section__inner">
                    <button type="button" className={`c-button c-button--outline c-button--small c-button--dark ${this.state.isLoadingMore ? ' c-button--loading' : ''}`} onClick={this.handleShowMore.bind(this)} aria-label="Load more supporters club results">Show more</button>
                  </div>
                </div>
              }
            </div>
          }

        </div>

      </div>
    );
  }
};

module.exports = SupportersClubSearchModule;



// WEBPACK FOOTER //
// ./src/components/SupportersClub/Search.js